export const localeLabels = {
  en: "English",
  ru: "Русский",
  de: "Deutsch",
  es: "Español",
  sr: "Srpski",
  uk: "Українська",
};
